import type {ReactElement} from 'react';
import type {PublishingOptionsProps} from './publishing-options.types';
import {PublishingOption} from './publishing-options.types';
import {ControlledListItemType7} from '@Components/controlled-list/components/controlled-list-item-type-7';
import {LoadingStates} from '@Utils/loading.util';
import {ChatImageActionPanelId} from '@Components/ai-chat-window/components/generated-image-actions-icons/generated-image-actions-icons.types';
import {closeModal} from '@Components/modal-container/modal-container-reducer';
import {getPublishingOptionDefinition} from './publishing-options.library';
import styles from './publishing-options.module.scss';

export function PublishingOptions({removeLastItemBottomMargin = true, excludedOptions = [], ...props}: PublishingOptionsProps): ReactElement {
  const getPublishingOptions = (): ReactElement => {
    const isDisabled = props.loadingStates.publishingLoadingState === LoadingStates.LOADING;
    const visibleOptions = [PublishingOption.PUBLISH_TO_SOCIAL_MEDIA, PublishingOption.PROMOTE_AS_EVENT, PublishingOption.PUBLISH_AS_EMAIL_CAMPAIGN].filter(
      (option) => !excludedOptions.includes(option)
    );

    const isLastVisibleOption = (option: PublishingOption): boolean => {
      return visibleOptions[visibleOptions.length - 1] === option;
    };

    const getItemClassName = (option: PublishingOption): string => {
      return `radius-8 ${removeLastItemBottomMargin && isLastVisibleOption(option) ? '_unmargin' : ''}`;
    };

    const getPublishingOptionListItem = (option: PublishingOption): ReactElement => {
      const definition = getPublishingOptionDefinition(option, props);

      return (
        <ControlledListItemType7
          key={option}
          id={option}
          text={definition.text}
          icon={definition.icon}
          onClick={(): void => {
            closeModal(ChatImageActionPanelId.MORE_OPTIONS_DROPDOWN_MODAL_PANEL_ID);
            void definition.publish();
          }}
          iconClasses={definition.hasPremiumCrown ? styles.crownIcon : ''}
          className={getItemClassName(option)}
          isLoading={props.loadingStates.loadingPublishingOption === option && props.loadingStates.publishingLoadingState === LoadingStates.LOADING}
          isDisabled={isDisabled}
        />
      );
    };

    return <>{visibleOptions.map(getPublishingOptionListItem)}</>;
  };

  return getPublishingOptions();
}
